"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mandolin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1.343-dev.d889c8c
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenterApi = exports.PresenterApiFactory = exports.PresenterApiFp = exports.PresenterApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * PresenterApi - axios parameter creator
 * @export
 */
exports.PresenterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles: (userId, presenterOrganizationRoleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling assignMemberRoles.');
            }
            // verify required parameter 'presenterOrganizationRoleDTO' is not null or undefined
            if (presenterOrganizationRoleDTO === null || presenterOrganizationRoleDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRoleDTO', 'Required parameter presenterOrganizationRoleDTO was null or undefined when calling assignMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/assign`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRoleDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRoleDTO !== undefined ? presenterOrganizationRoleDTO : {}) : (presenterOrganizationRoleDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition: (associateFileDefinitionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'associateFileDefinitionRequestDTO' is not null or undefined
            if (associateFileDefinitionRequestDTO === null || associateFileDefinitionRequestDTO === undefined) {
                throw new base_1.RequiredError('associateFileDefinitionRequestDTO', 'Required parameter associateFileDefinitionRequestDTO was null or undefined when calling associateFileDefinition.');
            }
            const localVarPath = `/fanData/v1/csvUpload/associateFileDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof associateFileDefinitionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(associateFileDefinitionRequestDTO !== undefined ? associateFileDefinitionRequestDTO : {}) : (associateFileDefinitionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/integration/mailchimp/audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl: (uploadDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uploadDate' is not null or undefined
            if (uploadDate === null || uploadDate === undefined) {
                throw new base_1.RequiredError('uploadDate', 'Required parameter uploadDate was null or undefined when calling getPreSignedUrl.');
            }
            const localVarPath = `/fanData/v1/csvUpload/getPreSignedUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (uploadDate !== undefined) {
                localVarQueryParameter['uploadDate'] = (uploadDate instanceof Date) ?
                    uploadDate.toISOString() :
                    uploadDate;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember: (presenterOrganizationInviteMemberDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterOrganizationInviteMemberDTO' is not null or undefined
            if (presenterOrganizationInviteMemberDTO === null || presenterOrganizationInviteMemberDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationInviteMemberDTO', 'Required parameter presenterOrganizationInviteMemberDTO was null or undefined when calling inviteOrgMember.');
            }
            const localVarPath = `/v1/organization/members/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationInviteMemberDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationInviteMemberDTO !== undefined ? presenterOrganizationInviteMemberDTO : {}) : (presenterOrganizationInviteMemberDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberOrganizations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/members/current/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling listMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/list`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/organization/members/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRoles: (startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/auth0/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} roleId
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions: (roleId, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new base_1.RequiredError('roleId', 'Required parameter roleId was null or undefined when calling listPermissions.');
            }
            const localVarPath = `/v1/auth0/roles/{roleId}/permissions`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGetSpotifyArtists: (searchText, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchText' is not null or undefined
            if (searchText === null || searchText === undefined) {
                throw new base_1.RequiredError('searchText', 'Required parameter searchText was null or undefined when calling openGetSpotifyArtists.');
            }
            const localVarPath = `/presenter/v1/spotify/artist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback: (type, presenterAuthCallbackRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling presenterAuthCallback.');
            }
            // verify required parameter 'presenterAuthCallbackRequestDTO' is not null or undefined
            if (presenterAuthCallbackRequestDTO === null || presenterAuthCallbackRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterAuthCallbackRequestDTO', 'Required parameter presenterAuthCallbackRequestDTO was null or undefined when calling presenterAuthCallback.');
            }
            const localVarPath = `/presenter/v1/integration/{type}/oauthCallback`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterAuthCallbackRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterAuthCallbackRequestDTO !== undefined ? presenterAuthCallbackRequestDTO : {}) : (presenterAuthCallbackRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets: (presenterCreateTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterCreateTicketRequestDTO' is not null or undefined
            if (presenterCreateTicketRequestDTO === null || presenterCreateTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterCreateTicketRequestDTO', 'Required parameter presenterCreateTicketRequestDTO was null or undefined when calling presenterCreateTickets.');
            }
            const localVarPath = `/presenter/v1/tickets/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterCreateTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterCreateTicketRequestDTO !== undefined ? presenterCreateTicketRequestDTO : {}) : (presenterCreateTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats: (showId, startAfter, limit, excludePast, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling presenterListShowTicketStats.');
            }
            const localVarPath = `/presenter/v1/show/ticketStats/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShows: (artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (beforeDate !== undefined) {
                localVarQueryParameter['beforeDate'] = (beforeDate instanceof Date) ?
                    beforeDate.toISOString() :
                    beforeDate;
            }
            if (afterDate !== undefined) {
                localVarQueryParameter['afterDate'] = (afterDate instanceof Date) ?
                    afterDate.toISOString() :
                    afterDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket: (presenterReassignTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterReassignTicketRequestDTO' is not null or undefined
            if (presenterReassignTicketRequestDTO === null || presenterReassignTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterReassignTicketRequestDTO', 'Required parameter presenterReassignTicketRequestDTO was null or undefined when calling presenterReassignTicket.');
            }
            const localVarPath = `/presenter/v1/tickets/reassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterReassignTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterReassignTicketRequestDTO !== undefined ? presenterReassignTicketRequestDTO : {}) : (presenterReassignTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection: (type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling presenterStitchConnection.');
            }
            const localVarPath = `/presenter/v1/integration/{type}/stitch`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember: (presenterOrganizationRemoveMemberDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterOrganizationRemoveMemberDTO' is not null or undefined
            if (presenterOrganizationRemoveMemberDTO === null || presenterOrganizationRemoveMemberDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRemoveMemberDTO', 'Required parameter presenterOrganizationRemoveMemberDTO was null or undefined when calling removeOrgMember.');
            }
            const localVarPath = `/v1/organization/members/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRemoveMemberDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRemoveMemberDTO !== undefined ? presenterOrganizationRemoveMemberDTO : {}) : (presenterOrganizationRemoveMemberDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTicket: (ticketId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ticketId' is not null or undefined
            if (ticketId === null || ticketId === undefined) {
                throw new base_1.RequiredError('ticketId', 'Required parameter ticketId was null or undefined when calling revokeTicket.');
            }
            const localVarPath = `/presenter/v1/tickets/revoke/{ticketId}`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} showIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketCountByStatus: (showIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showIds' is not null or undefined
            if (showIds === null || showIds === undefined) {
                throw new base_1.RequiredError('showIds', 'Required parameter showIds was null or undefined when calling ticketCountByStatus.');
            }
            const localVarPath = `/presenter/v1/tickets/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (showIds) {
                localVarQueryParameter['showIds'] = showIds;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles: (userId, presenterOrganizationRoleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling unassignMemberRoles.');
            }
            // verify required parameter 'presenterOrganizationRoleDTO' is not null or undefined
            if (presenterOrganizationRoleDTO === null || presenterOrganizationRoleDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRoleDTO', 'Required parameter presenterOrganizationRoleDTO was null or undefined when calling unassignMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/unassign`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRoleDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRoleDTO !== undefined ? presenterOrganizationRoleDTO : {}) : (presenterOrganizationRoleDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateNameDTO} updateNameDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateName: (updateNameDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateNameDTO' is not null or undefined
            if (updateNameDTO === null || updateNameDTO === undefined) {
                throw new base_1.RequiredError('updateNameDTO', 'Required parameter updateNameDTO was null or undefined when calling updateName.');
            }
            const localVarPath = `/presenter/v1/members/current/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateNameDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateNameDTO !== undefined ? updateNameDTO : {}) : (updateNameDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PresenterApi - functional programming interface
 * @export
 */
exports.PresenterApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).assignMemberRoles(userId, presenterOrganizationRoleDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition(associateFileDefinitionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).associateFileDefinition(associateFileDefinitionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).getCurrentOrganization(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).getIntegrations(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).getMailchimpAudiences(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl(uploadDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).getPreSignedUrl(uploadDate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember(presenterOrganizationInviteMemberDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).inviteOrgMember(presenterOrganizationInviteMemberDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberOrganizations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).listMemberOrganizations(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).listMemberRoles(userId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).listMembers(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRoles(startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).listOrgRoles(startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} roleId
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(roleId, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).listPermissions(roleId, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGetSpotifyArtists(searchText, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).openGetSpotifyArtists(searchText, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets(presenterCreateTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterCreateTickets(presenterCreateTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats(showId, startAfter, limit, excludePast, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterListShowTicketStats(showId, startAfter, limit, excludePast, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterListShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket(presenterReassignTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterReassignTicket(presenterReassignTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection(type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).presenterStitchConnection(type, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember(presenterOrganizationRemoveMemberDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).removeOrgMember(presenterOrganizationRemoveMemberDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTicket(ticketId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).revokeTicket(ticketId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} showIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketCountByStatus(showIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).ticketCountByStatus(showIds, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).unassignMemberRoles(userId, presenterOrganizationRoleDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateNameDTO} updateNameDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateName(updateNameDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.PresenterApiAxiosParamCreator(configuration).updateName(updateNameDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
/**
 * PresenterApi - factory interface
 * @export
 */
exports.PresenterApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return exports.PresenterApiFp(configuration).assignMemberRoles(userId, presenterOrganizationRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition(associateFileDefinitionRequestDTO, options) {
            return exports.PresenterApiFp(configuration).associateFileDefinition(associateFileDefinitionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization(options) {
            return exports.PresenterApiFp(configuration).getCurrentOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(options) {
            return exports.PresenterApiFp(configuration).getIntegrations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences(options) {
            return exports.PresenterApiFp(configuration).getMailchimpAudiences(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl(uploadDate, options) {
            return exports.PresenterApiFp(configuration).getPreSignedUrl(uploadDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember(presenterOrganizationInviteMemberDTO, options) {
            return exports.PresenterApiFp(configuration).inviteOrgMember(presenterOrganizationInviteMemberDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberOrganizations(options) {
            return exports.PresenterApiFp(configuration).listMemberOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles(userId, options) {
            return exports.PresenterApiFp(configuration).listMemberRoles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(options) {
            return exports.PresenterApiFp(configuration).listMembers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRoles(startAfter, limit, options) {
            return exports.PresenterApiFp(configuration).listOrgRoles(startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} roleId
         * @param {number} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(roleId, startAfter, limit, options) {
            return exports.PresenterApiFp(configuration).listPermissions(roleId, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGetSpotifyArtists(searchText, options) {
            return exports.PresenterApiFp(configuration).openGetSpotifyArtists(searchText, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options) {
            return exports.PresenterApiFp(configuration).presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets(presenterCreateTicketRequestDTO, options) {
            return exports.PresenterApiFp(configuration).presenterCreateTickets(presenterCreateTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats(showId, startAfter, limit, excludePast, options) {
            return exports.PresenterApiFp(configuration).presenterListShowTicketStats(showId, startAfter, limit, excludePast, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options) {
            return exports.PresenterApiFp(configuration).presenterListShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket(presenterReassignTicketRequestDTO, options) {
            return exports.PresenterApiFp(configuration).presenterReassignTicket(presenterReassignTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection(type, options) {
            return exports.PresenterApiFp(configuration).presenterStitchConnection(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember(presenterOrganizationRemoveMemberDTO, options) {
            return exports.PresenterApiFp(configuration).removeOrgMember(presenterOrganizationRemoveMemberDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTicket(ticketId, options) {
            return exports.PresenterApiFp(configuration).revokeTicket(ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} showIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ticketCountByStatus(showIds, options) {
            return exports.PresenterApiFp(configuration).ticketCountByStatus(showIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return exports.PresenterApiFp(configuration).unassignMemberRoles(userId, presenterOrganizationRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateNameDTO} updateNameDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateName(updateNameDTO, options) {
            return exports.PresenterApiFp(configuration).updateName(updateNameDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PresenterApi - object-oriented interface
 * @export
 * @class PresenterApi
 * @extends {BaseAPI}
 */
class PresenterApi extends base_1.BaseAPI {
    /**
     *
     * @param {PresenterApiAssignMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    assignMemberRoles(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).assignMemberRoles(requestParameters.userId, requestParameters.presenterOrganizationRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiAssociateFileDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    associateFileDefinition(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).associateFileDefinition(requestParameters.associateFileDefinitionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    getCurrentOrganization(options) {
        return exports.PresenterApiFp(this.configuration).getCurrentOrganization(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    getIntegrations(options) {
        return exports.PresenterApiFp(this.configuration).getIntegrations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    getMailchimpAudiences(options) {
        return exports.PresenterApiFp(this.configuration).getMailchimpAudiences(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiGetPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    getPreSignedUrl(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).getPreSignedUrl(requestParameters.uploadDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiInviteOrgMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    inviteOrgMember(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).inviteOrgMember(requestParameters.presenterOrganizationInviteMemberDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    listMemberOrganizations(options) {
        return exports.PresenterApiFp(this.configuration).listMemberOrganizations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiListMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    listMemberRoles(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).listMemberRoles(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    listMembers(options) {
        return exports.PresenterApiFp(this.configuration).listMembers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiListOrgRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    listOrgRoles(requestParameters = {}, options) {
        return exports.PresenterApiFp(this.configuration).listOrgRoles(requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiListPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    listPermissions(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).listPermissions(requestParameters.roleId, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiOpenGetSpotifyArtistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    openGetSpotifyArtists(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).openGetSpotifyArtists(requestParameters.searchText, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterAuthCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterAuthCallback(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).presenterAuthCallback(requestParameters.type, requestParameters.presenterAuthCallbackRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterCreateTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterCreateTickets(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).presenterCreateTickets(requestParameters.presenterCreateTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterListShowTicketStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterListShowTicketStats(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).presenterListShowTicketStats(requestParameters.showId, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterListShows(requestParameters = {}, options) {
        return exports.PresenterApiFp(this.configuration).presenterListShows(requestParameters.artistId, requestParameters.cobrand, requestParameters.state, requestParameters.type, requestParameters.venueId, requestParameters.beforeDate, requestParameters.afterDate, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterReassignTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterReassignTicket(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).presenterReassignTicket(requestParameters.presenterReassignTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiPresenterStitchConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    presenterStitchConnection(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).presenterStitchConnection(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invitations
     * @param {PresenterApiRemoveOrgMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    removeOrgMember(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).removeOrgMember(requestParameters.presenterOrganizationRemoveMemberDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiRevokeTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    revokeTicket(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).revokeTicket(requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiTicketCountByStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    ticketCountByStatus(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).ticketCountByStatus(requestParameters.showIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiUnassignMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    unassignMemberRoles(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).unassignMemberRoles(requestParameters.userId, requestParameters.presenterOrganizationRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PresenterApiUpdateNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresenterApi
     */
    updateName(requestParameters, options) {
        return exports.PresenterApiFp(this.configuration).updateName(requestParameters.updateNameDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PresenterApi = PresenterApi;
